<template>
  <div class="stats-icons" :class="{ colored, 'width-auto': autoWidth }">
    <div v-for="(stat, idx) in map" :key="idx">
      <component :is="stat.icon" :class="`icon-${stat.key}`" />
      <div class="description">
        <span>{{ stat.value }}</span>
        {{ stat.description }}
      </div>
    </div>
  </div>
</template>

<script>
import IconClock from '../../assets/svg/icon-auto-clock.svg?vue-component';
import IconMonitorPlay from '../../assets/svg/icon-auto-monitor-play.svg?vue-components';
import IconPeople from '../../assets/svg/icon-auto-meet-the-team.svg?vue-components';

export default {
  components: { IconClock, IconMonitorPlay, IconPeople },
  props: {
    stats: { type: Object, default: () => ({}), required: true },
    order: { type: Array, default: () => ([]), required: false },
    colored: Boolean,
    autoWidth: Boolean,
  },
  computed: {
    map() {
      if (this.order.length) {
        const array = [];
        this.order.forEach((item) => {
          array.push(this.getStat(item));
        });

        return array;
      }

      return [
        this.getStat('video'),
        this.getStat('exercises'),
        this.getStat('students'),
      ];
    },
  },
  methods: {
    getStat(key) {
      let object = {};

      if (key === 'exercises') {
        object = { icon: this.getIcon(key), description: 'Exercises', value: `${this.stats.rounded.exercises}+` };
      }

      if (key === 'video') {
        object = { icon: this.getIcon(key), description: 'Hours of video', value: `${this.stats.rounded.videoDuration}+` };
      }

      if (key === 'projects') {
        object = { icon: this.getIcon(key), description: 'Portfolio Projects', value: `${this.stats.rounded.projects}+` };
      }

      if (key === 'courses') {
        object = { icon: this.getIcon(key), description: 'Courses', value: `${this.stats.rounded.courses}+` };
      }

      if (key === 'students') {
        object = { icon: this.getIcon('students'), description: 'Students', value: `${this.$c.text('students.count')}+` };
      }

      if (key === 'instructors') {
        object = { icon: this.getIcon('instructors'), description: 'Instructors', value: `${this.stats.rounded.instructors}+` };
      }

      if (key === 'certificates') {
        object = { icon: this.getIcon('certificates'), description: 'Certificates Earned', value: `${this.stats.rounded.certificatesEarned}+` };
      }

      if (key === 'completedCourses') {
        object = { icon: this.getIcon('courses'), description: 'Courses Completed', value: `${this.stats.rounded.completedCourses}+` };
      }

      if (key === 'rating') {
        object = { icon: this.getIcon('rating'), description: 'trustpilot Rating', value: '4.7/5' };
      }

      if (key === 'reviews') {
        object = { icon: this.getIcon('reviews'), description: 'Reviews', value: '6K+' };
      }

      return { ...object, key };
    },
    getIcon(key) {
      return require(`../../assets/svg/icon-stats-${key}.svg?vue-component`);
    },
  },
};
</script>

<style lang="scss" scoped>
.stats-icons {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  max-width: 970px;
  height: 69px;
  margin: 58px auto 0 auto;

  > div {
    width: 202px;
    display: flex;
    flex-direction: row;

    .description {
      display: flex;
      flex-direction: column;
      align-self: center;
      font-weight: 500;
      color: var(--main-light);

      span {
        font-weight: 400;
        font-size: 40px;
      }
    }
  }

  svg {
    margin-right: 20px;
    flex: 0 0 auto;

    path[stroke="#000C1F"] {
      stroke: var(--main-light);
    }

    path[stroke="#3DAFB8"] {
      stroke: var(--extreme-blue);
    }
  }

  &.width-auto {
    max-width: 100%;

    > div {
      width: auto;
    }
  }

  &.colored {
    svg {
      color: var(--accent);
    }
  }

  @include bp($bp-laptop) {
    > div .description span {
      font-size: 32px;
    }
  }

  @media screen and (max-width: 720px) {
    height: auto;
    justify-content: center;
    flex-direction: column;
    margin: var(--spacing-40) auto;
    padding: 0;

    &.width-auto > div {
      width: 204px;
    }

    > div {
      margin-left: auto;
      margin-right: auto;

      .description span {
        font-size: 32px;
      }

      &:not(:last-of-type) {
        margin-bottom: var(--spacing-44);
      }

      svg {
        height: 70px;
        width: 70px;
      }
    }
  }
}
</style>
